import { useQuery, useQueryClient, UseQueryOptions } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import getCompanyById from "../getCompanyById";
import { queryKeys } from "../queryKeys";
import { portalApiClient } from "../apiClient";
import { apiUrls } from "src/consts/ApiUrls";

export default function useFeatures() {
  const { companyId } = useParams();
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: queryKeys.featuresByCompanyId(companyId),
    queryFn: async () => {
      if (!companyId) return null;
      const data = await portalApiClient.get(
        apiUrls.features.company.url(String(companyId))
      );
      return data.data;
    },
    staleTime: Infinity,
  });
  return {
    ...query,
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.featuresByCompanyId(companyId),
      }),
  };
}
